module.exports = __webpack_public_path__ + "img/bandwidth.png?bd93d2fbfc9bcd4c13d69605bfb9de04";